/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';

//Includes
import { ALL_ROUTES, HOME_TODAY_SCREEN, PERMISSION_CONSTANTS, SYNC_SERVICE, COMMON } from '../../global/Constants';
import SyncServices from '../../providers/SyncServices';
import AuthService from '../../providers/AuthService';
import DataProvider from '../../providers/DataProvider';
import { HeaderTypes, HomeActivityType, ActivityType, ActivityStatusType, CROP_GROUP } from "../../global/Enum";
import Utilities from '../../global/Utilities';
import ApiServices from "../../providers/ApiServices";
import './home-today.css';

//Components
import Loader from '../common/loader/Loader';
import SyncLoader from '../common/loader/SyncLoader';
import Header from '../common/Header';
import ActivityItem from '../common/ActivityItem';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const allMasterKeys = [
  SYNC_SERVICE.ACTION_QUALIFICATION,
  SYNC_SERVICE.ACTION_PHONE_APP,
  SYNC_SERVICE.ACTION_IRRIGATION_SOURCE,
  SYNC_SERVICE.ACTION_AREA_UNIT,
  SYNC_SERVICE.ACTION_WEIGHT_UNIT,
  SYNC_SERVICE.ACTION_INFLUENCE_FACTOR,
  SYNC_SERVICE.ACTION_KRISHAK_SOURCE_OF_INFORMATION,
  SYNC_SERVICE.ACTION_KRISHAK_DECISION_MAKING,
  SYNC_SERVICE.ACTION_CROP_DAYS,
  SYNC_SERVICE.ACTION_CROP_PICKING,
  SYNC_SERVICE.ACTION_CROP_PLOT_VISIT_CROP_HEALTH,
  SYNC_SERVICE.ACTION_CROP_QUALITY_GIVEN,
  SYNC_SERVICE.ACTION_CROP_ROW_DISTANCE,
  SYNC_SERVICE.ACTION_CROP_SOWING_SPACING,
  SYNC_SERVICE.ACTION_DAYS,
  SYNC_SERVICE.ACTION_FEEDBACK,
  SYNC_SERVICE.ACTION_FIELD_DAMAGE_REASON,
  SYNC_SERVICE.ACTION_FIELD_DAY_ATTEND,
  SYNC_SERVICE.ACTION_FIELD_DAY_MANAGER,
  SYNC_SERVICE.ACTION_LEVEL,
  SYNC_SERVICE.ACTION_PICKING,
  SYNC_SERVICE.ACTION_PLOT_VISIT_CROP_HEALTH,
  SYNC_SERVICE.ACTION_PLOT_VISIT_STAGE,
  SYNC_SERVICE.ACTION_QUALITY_GIVEN,
  SYNC_SERVICE.ACTION_REJECT,
  SYNC_SERVICE.ACTION_ROW_DISTANCE,
  SYNC_SERVICE.ACTION_SOWING_SPACING,
  SYNC_SERVICE.ACTION_TYPE_OF_SAMPLE,
  SYNC_SERVICE.ACTION_STATE,
  SYNC_SERVICE.ACTION_DISTRICT,
  SYNC_SERVICE.ACTION_TEHSIL,
  SYNC_SERVICE.ACTION_VILLAGE,
  SYNC_SERVICE.ACTION_CROP,
  SYNC_SERVICE.ACTION_HYBRID,
  SYNC_SERVICE.ACTION_HYBRID_LOCATION_TEHSIL,
  SYNC_SERVICE.ACTION_USER_LOCATION,
  SYNC_SERVICE.ACTION_EMPLOYEE,
  SYNC_SERVICE.ACTION_COMPETITOR_HYBRID,
  SYNC_SERVICE.ACTION_RETAILER,
  SYNC_SERVICE.ACTION_SUB_ACTIVITY,
  SYNC_SERVICE.ACTION_SEASON,
  SYNC_SERVICE.ACTION_SAMPLE_TO_SALE_CROP,
  SYNC_SERVICE.ACTION_GROVER,
  SYNC_SERVICE.ACTION_CROP_GROUP,
  SYNC_SERVICE.ACTION_USER_CROP,
  SYNC_SERVICE.ACTION_ERROR_LOG,
  SYNC_SERVICE.ACTION_LEVEL,
  SYNC_SERVICE.ACTION_KRISHAK_CROP,
  SYNC_SERVICE.ACTION_DAKSH_COMPETITOR_HYBRID,
  SYNC_SERVICE.ACTION_CROP_SEASON_SUB_ACTIVITY
]


class HomeTodayPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_FARMER,
      selectedFDO: null,
      userName: "",
      activityList: null,
      pendingActivityList: null,
      fdoList: [],
      todayData: null,
      searchedValue: '',
      selectedActivityItem: null,
      mobileNumber: '',
      krishakInfo: null,
      isCheckIn: false,
      startTime: null,
      endTime: null,
      isLoading: false,
      isSyncLoading: false,
      latitude: null,
      longitude: null,
      todayLog: null,
      isFDO: false,
      tableName: SYNC_SERVICE.MASTER_TABLE,
      retailerInfo: null,
      hostFarmerName: '',
      isHost: false,
    }
    this.searchTimerHandle = null;
  }

  async componentDidMount() {
    toast.configure();

    const session = AuthService.getSession();
    if (session) {
      // If User Don't have Activity Module Permission
      const showAddActivity = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_INDIVIDUAL_VISIT);
      if (!showAddActivity?.view) {
        this.props.history.replace(ALL_ROUTES.MORE_MENU_ROUTE);
        return;
      }

      // For First Time Sync
      const lastSyncDate = String(localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE));
      //Utilities.LogPrint("Last Sync Date => ", lastSyncDate);
      if (lastSyncDate === "null") {
        localStorage.setItem(SYNC_SERVICE.LAST_SYNC_DATE, "2020-01-01 00:00:00");
        localStorage.setItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE, Utilities.getLastMonthDate());
      }

      await DataProvider.getInstance().fetchMasterData();
      const session = AuthService.getSession();
      this.getActivityFDOApi();

      this.setState({ userName: session?.user?.name }, () => {
        const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
        if (showBulkUpload?.view) {
          //With API
          //this.getFdoActivityByDateApi();

          //Offline
          this.getFDOActivities();
        } else {
          //With API
          //this._getTodayActivityApi();

          //Offline
          this.getActivities();
        }
      });
      this.checkTodayStartDay();
      this.getUserLocation();
    } else {
      this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }


  getFDOActivities = () => {

    SyncServices.getFDOActivities().then(data => {
      let todayData = {}
      //Utilities.LogPrint('FDO Activity', data);
      const countIV = data.filter(item => item.activity_type_id === ActivityType.INDIVIDUAL_VISIT).length;
      const countGM = data.filter(item => item.activity_type_id === ActivityType.GROUP_MEETING).length;
      const countSD = data.filter(item => item.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION).length;
      const countS2S = data.filter(item => item.activity_type_id === ActivityType.SAMPLE_TO_SALE).length;
      //Utilities.LogPrint('FDO countIV', countIV);
      //Utilities.LogPrint('FDO countGM', countGM);
      //Utilities.LogPrint('FDO countSD', countSD);
      //Utilities.LogPrint('FDO countS2S', countS2S);

      SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(users => {
        //Utilities.LogPrint("FDO List:", users);

        let fdo = [];
        if (users) {
          const session = AuthService.getSession();
          var user = users?.find(item => item.user_id === session?.user.user_id);
          if (user) {
            user['name'] = "a"
            //user['name'] = "Self"
          }

          // const fdoUsers = users.filter(item => (item.server_employee_id === session?.user.server_employee_id
          //   || item.server_manager_id === session?.user.server_employee_id) && item.is_active === 1);
          //Utilities.LogPrint("FDO_USERS", fdoUsers);

          // Sort Array Based On Alphabetic Order
          users.sort((a, b) => a.name.localeCompare(b.name))

          let totalActivityCount = 0;
          let completedActivityCount = 0;
          let pendingReviewActivityCount = 0;
          users.forEach(element => {
            if (element?.user_id === session?.user.user_id) {
              totalActivityCount = data.filter(item => item.assigned_user_id === element.user_id).length;
              completedActivityCount = data.filter(item => item.assigned_user_id === element.user_id && item.activity_status_id === ActivityStatusType.COMPLETED).length;
              pendingReviewActivityCount = data.filter(item => item.assigned_user_id === element.user_id && item.activity_status_id === ActivityStatusType.PENDING_REVIEW).length;

              // FOR TM LOGIN
              // totalActivityCount = data.filter(item => item.assigned_user_id === element.user_id).length;
              // //Utilities.LogPrint('FDO Activity Count', totalActivityCount);
              // completedActivityCount = data.filter(item => item.assigned_user_id === element.user_id && item.activity_status_id === ActivityStatusType.COMPLETED).length;
              // //Utilities.LogPrint('FDO Completed Count', completedActivityCount);
              // pendingReviewActivityCount = data.filter(item => item.assigned_user_id === element.user_id && item.activity_status_id === ActivityStatusType.PENDING_REVIEW).length;
              // //Utilities.LogPrint('FDO Pending Count', pendingReviewActivityCount);

            } else if (element.is_employee === 1) {

              totalActivityCount = data.filter(item => item.assigned_user_id === element.user_id).length;
              completedActivityCount = data.filter(item => item.assigned_user_id === element.user_id &&
                item.activity_status_id === ActivityStatusType.COMPLETED).length;
              pendingReviewActivityCount = data.filter(item => item.assigned_user_id === element.user_id &&
                item.activity_status_id === ActivityStatusType.PENDING_REVIEW).length;

            } else {
              totalActivityCount = data.filter(item => item.assigned_user_id === element.user_id).length;
              completedActivityCount = data.filter(item => item.assigned_user_id === element.user_id && item.activity_status_id === ActivityStatusType.COMPLETED).length;
              pendingReviewActivityCount = data.filter(item => item.assigned_user_id === element.user_id && item.activity_status_id === ActivityStatusType.PENDING_REVIEW).length;

            }


            let user = {
              user_id: element.user_id,
              name: element.name === 'a' ? "Self" : element.name,
              totalActivity: totalActivityCount,
              completedActivity: completedActivityCount,
              pendingReviewActivity: pendingReviewActivityCount,
              is_employee: element?.is_employee
            }
            fdo.push(user);
          });
        }
        //Utilities.LogPrint("FDO Array", fdo);

        todayData = {
          IV: countIV,
          GM: countGM,
          SD: countSD,
          S2S: countS2S,
          fdo: fdo
        }
        Utilities.LogPrint("FDO Final Array", todayData);
        this.setState({
          todayData: todayData,
          isLoading: false
        });

      });
    });

  }

  getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const coords = position.coords;
        //Utilities.LogPrint("Latitude is :", coords.latitude);
        //Utilities.LogPrint("Longitude is :", coords.longitude);

        this.setState({
          latitude: coords.latitude.toFixed(6),
          longitude: coords.longitude.toFixed(6)
        });

      }, (error) => {
        //this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' })
        Utilities.LogPrint("Error Code = " + error.code + " - " + error.message);
      });
    } else {
      //toast.info('GPS Location Not Found!');
    }
  }

  checkTodayStartDay = () => {
    SyncServices.getUserActivityByDate(Utilities.getCurrentDate()).then(item => {
      //Utilities.LogPrint("getUserActivityByDate", item);
      if (item !== null) {
        const isCheck = item.startTime === null ? false : true;
        this.setState({
          startTime: item.startTime,
          isCheckIn: isCheck,
          todayLog: item,
          endTime: item.endTime
        });
      }
    });
  }

  // For Start Day & End Day 
  addUserStartEndDayApi = () => {
    if (Utilities.isNetworkConnected()) {
      const { startTime, latitude, longitude, todayLog } = this.state;
      this.setState({ isLoading: true });
      const session = AuthService.getSession();
      //Utilities.LogPrint("Start Time", this.state.startTime);

      var params = {}
      if (startTime === null) {
        params = {
          user_id: session?.user.user_id,
          date: Utilities.getCurrentDate(), //"2021-03-13",//
          start_time: Utilities.getTimeAmPm(),
          start_location: latitude + "," + longitude
        };
        SyncServices.addUserActivity(params);
        //this.setState({ startTime: Utilities.getTimeAmPm() })
      } else {
        const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
        if (!showBulkUpload?.view) {
          this.syncData();
        }

        params = {
          user_id: session?.user.user_id,
          date: Utilities.getCurrentDate(),//"2021-03-13",//
          //start_time: this.state.start_time,
          end_time: Utilities.getTimeAmPm(),
          end_location: latitude + "," + longitude,
        };
        SyncServices.updateUserActivity(todayLog?.key, params);
        //this.setState({ endTime: Utilities.getTimeAmPm() })
      }
      try {
        ApiServices.addUserStartEndDay(JSON.stringify(params))
          .then(response => {
            this.setState({ isLoading: false });
            var status = response.success;
            if (status) {
              Utilities.LogPrint("addUserStartEndDayApi", response);
              //this._getTodayActivityApi();
              this.checkTodayStartDay();

              const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
              if (!showBulkUpload?.view && startTime === null) {
                this.syncData();
              } else {
                this.syncAllMasterData();
              }
            } else {
              if (response.message === COMMON.TOKEN_EXPIRED) {
                Utilities.tokenExpiredRedirectToLogin();
              }
            }
          })
          .catch(error => {
            Utilities.LogPrint("addUserStartEndDayApi-catch", error);
          });
      }
      catch (error) {
        Utilities.LogPrint("addUserStartEndDayApi-error", error);
      }

      // if (latitude !== null && longitude !== null) {

      //   var params = {}
      //   if (startTime === null) {
      //     params = {
      //       user_id: session ?.user.user_id,
      //       date: Utilities.getCurrentDate(), //"2021-03-13",//
      //       start_time: Utilities.getTimeAmPm(),
      //       start_location: latitude + "," + longitude
      //     };
      //     SyncServices.addUserActivity(params);
      //     //this.setState({ startTime: Utilities.getTimeAmPm() })
      //   } else {
      //     this.syncData();
      //     params = {
      //       user_id: session ?.user.user_id,
      //       date: Utilities.getCurrentDate(),//"2021-03-13",//
      //       //start_time: this.state.start_time,
      //       end_time: Utilities.getTimeAmPm(),
      //       end_location: latitude + "," + longitude,
      //     };
      //     SyncServices.updateUserActivity(todayLog ?.key, params);
      //     //this.setState({ endTime: Utilities.getTimeAmPm() })
      //   }
      //   try {
      //     ApiServices.addUserStartEndDay(JSON.stringify(params))
      //       .then(response => {
      //         this.setState({ isLoading: false });
      //         var status = response.success;
      //         if (status) {
      //           Utilities.LogPrint("addUserStartEndDayApi", response.data);
      //           //this._getTodayActivityApi();
      //           this.checkTodayStartDay();

      //           if (startTime === null) {
      //             this.syncData();
      //           }

      //         }
      //       })
      //       .catch(error => {
      //         Utilities.LogPrint("addUserStartEndDayApi-catch", error);
      //       });
      //   }
      //   catch (error) {
      //     Utilities.LogPrint("addUserStartEndDayApi-error", error);
      //   }

      // } else {
      //   toast.info('GPS Location Not Found!');
      // }

    } else {
      toast.info(COMMON.NO_INTERNET_CONNECTION);
    }

  }

  // For Testing
  syncActivities = async () => {
    this.syncAllActivityData();
  }

  syncData = async () => {
    this.syncAllMasterData();
  }


  //OFFLINE SYNC Activity LOGIC
  syncAllActivityData() {
    //this.storeSampleToSaleById();
    SyncServices.storeSampleToSaleById();

    const activities = new Promise(function (resolve) {
      SyncServices.getLocalActivities("is_synced", "false").then(activities => {
        Utilities.LogPrint("Local Activities ===============", activities);

        let activityArray = [];
        if (activities != null || activities?.length > 0) {
          for (let i = 0; i < activities.length; i++) {
            const activity = activities[i];

            if (activity?.activity_type_id === ActivityType.INDIVIDUAL_VISIT) {

              // For Activity IV Image
              let activity_image = [];
              for (let j = 0; j < activity?.data?.activity_images.length; j++) {
                const objImage = activity?.data?.activity_images[j];
                if (objImage.image_id === 0) {
                  let obj = {
                    temp_image_id: objImage.temp_image_id,
                    name: objImage.name
                  }
                  activity_image.push(obj);
                }
              }
              // For Activity Delete Image
              if (activity?.data?.deletedImages.length > 0) {
                const deletedImages = activity?.data?.deletedImages;
                for (let i = 0; i < deletedImages?.length; i++) {
                  const objImage = deletedImages[i];
                  activity_image.push(objImage);
                }
              }
              //Utilities.LogPrint("Image", activity_image);

              let objRequest = {};
              if (activity?.data === null) {
                objRequest = {
                  temp_activity_id: activity?.key,
                  activity_id: activity?.activity_id,
                  activity_date: activity?.created_at,
                  activity_type_id: activity?.activity_type_id,
                  activity_status_id: activity?.activity_status_id,
                  assigned_user_id: activity?.assigned_user_id,
                  crop_id: activity?.crop_id,
                  hybrid_id: activity?.hybrid_id,
                  village_id: activity?.village_id,
                  krishak_id: activity?.krishak_id,
                  retailer_id: activity?.retailer_id,
                  is_active: activity?.is_active
                  //temp_krishak_id: activity?.temp_krishak_id,
                }
              } else {
                objRequest = {
                  temp_activity_id: activity?.key,
                  activity_id: activity?.activity_id,
                  activity_date: activity?.created_at,
                  activity_type_id: activity?.activity_type_id,
                  activity_status_id: activity?.activity_status_id,
                  assigned_user_id: activity?.assigned_user_id,
                  crop_id: activity?.crop_id,
                  hybrid_id: activity?.hybrid_id,
                  village_id: activity?.village_id,
                  krishak_id: activity?.krishak_id,
                  retailer_id: activity?.retailer_id,
                  temp_krishak_id: activity?.temp_krishak_id,
                  temp_krishak_phone: activity?.temp_krishak_phone,
                  is_active: activity?.is_active,
                  data: {
                    activity_id: activity?.data?.activity_id,
                    krishak_id: activity?.data?.krishak_id,
                    retailer_id: activity?.data?.retailer_id,
                    season_id: activity?.data?.season_id,
                    sub_activity_id: activity?.data?.sub_activity_id,
                    remark: activity?.data?.remark,
                    latitude: activity?.data?.latitude,
                    longitude: activity?.data?.longitude,
                    activity_image: activity_image
                  }
                }
              }
              activityArray.push(objRequest);
            }

            if (activity?.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
              // For Activity SD Image
              let activity_image = [];
              for (let j = 0; j < activity?.data?.activity_images.length; j++) {
                const objImage = activity?.data?.activity_images[j];
                if (objImage.image_id === 0) {
                  let obj = {
                    temp_image_id: objImage.temp_image_id,
                    name: objImage.name
                  }
                  activity_image.push(obj);
                }
              }

              // For Activity Delete Image
              if (activity?.data?.deletedImages.length > 0) {
                const deletedImages = activity?.data?.deletedImages;
                for (let i = 0; i < deletedImages?.length; i++) {
                  const objImage = deletedImages[i];
                  activity_image.push(objImage);
                }
              }
              //Utilities.LogPrint("Image", activity_image);

              let objRequest = {}
              if (activity?.data === null) {
                objRequest = {
                  temp_activity_id: activity?.key,
                  activity_id: activity?.activity_id,
                  activity_date: activity?.created_at,
                  activity_type_id: activity?.activity_type_id,
                  activity_status_id: activity?.activity_status_id,
                  assigned_user_id: activity?.assigned_user_id,
                  crop_id: activity?.crop_id,
                  hybrid_id: activity?.hybrid_id,
                  village_id: activity?.village_id,
                  krishak_id: activity?.krishak_id,
                  retailer_id: activity?.retailer_id,
                  is_active: activity?.is_active,
                  //data: activity?.data
                }
              } else {
                objRequest = {
                  temp_activity_id: activity?.key,
                  activity_id: activity?.activity_id,
                  activity_date: activity?.created_at,
                  activity_type_id: activity?.activity_type_id,
                  activity_status_id: activity?.activity_status_id,
                  assigned_user_id: activity?.assigned_user_id,
                  crop_id: activity?.crop_id,
                  hybrid_id: activity?.hybrid_id,
                  village_id: activity?.village_id,
                  krishak_id: activity?.krishak_id,
                  retailer_id: activity?.retailer_id,
                  temp_krishak_id: activity?.temp_krishak_id,
                  temp_krishak_phone: activity?.temp_krishak_phone,
                  is_active: activity?.is_active,
                  data: {
                    activity_id: activity?.activity_id,
                    quantity_given_id: activity?.data?.quantity_given_id,
                    check_variety_id: activity?.data?.check_variety_id,
                    research: activity?.data?.research,
                    type_of_sample: activity?.data?.type_of_sample,
                    is_s2s: activity?.data?.is_s2s,
                    sample_distribution_near_retailer: activity?.data?.sample_distribution_near_retailer,
                    remark: activity?.data?.remark,
                    latitude: activity?.data?.latitude,
                    longitude: activity?.data?.longitude,
                    activity_image: activity_image
                  }
                }
              }
              activityArray.push(objRequest);
            }

            if (activity?.activity_type_id === ActivityType.GROUP_MEETING) {

              let group_meeting_image = [];
              for (let j = 0; j < activity?.data?.group_meeting_image.length; j++) {
                const objImage = activity?.data?.group_meeting_image[j];
                if (objImage.file !== undefined) {
                  group_meeting_image.push(objImage.name);
                }

              }

              let group_meeting_farmer_image = [];
              for (let j = 0; j < activity?.data?.farmerNumbersImageFiles.length; j++) {
                const objImage = activity?.data?.farmerNumbersImageFiles[j];
                if (objImage.file !== undefined) {
                  group_meeting_farmer_image.push(objImage.file.name);
                }
              }

              let objRequest = {}
              if (activity?.data === null) {
                objRequest = {
                  temp_activity_id: activity?.key,
                  activity_id: activity?.activity_id,
                  activity_date: activity?.created_at,
                  activity_type_id: activity?.activity_type_id,
                  activity_status_id: activity?.activity_status_id,
                  assigned_user_id: activity?.assigned_user_id,
                  crop_id: activity?.crop_id,
                  hybrid_id: activity?.hybrid_id,
                  village_id: activity?.village_id,
                  reporting_mobile: activity?.reporting_mobile,
                  is_active: activity?.is_active,
                  data: activity?.data
                }
              } else {
                objRequest = {
                  temp_activity_id: activity?.key,
                  activity_id: activity?.activity_id,
                  activity_date: activity?.created_at,
                  activity_type_id: activity?.activity_type_id,
                  activity_status_id: activity?.activity_status_id,
                  assigned_user_id: activity?.assigned_user_id,
                  crop_id: activity?.crop_id,
                  hybrid_id: activity?.hybrid_id,
                  village_id: activity?.village_id,
                  krishak_id: activity?.data?.krishak_id,
                  reporting_mobile: activity?.reporting_mobile,
                  is_active: activity?.is_active,
                  data: {
                    activity_id: activity?.activity_id,
                    krishak_id: activity?.data?.krishak_id,
                    temp_krishak_id: activity?.temp_krishak_id,
                    season_id: activity?.data?.season_id,
                    sub_activity_id: activity?.data?.sub_activity_id,
                    is_farmer_attend: activity?.data?.is_farmer_attend,
                    no_farmer_attend: activity?.data?.no_farmer_attend,
                    is_retailer_attend: activity?.data?.is_retailer_attend,
                    no_retailer_attend: activity?.data?.no_retailer_attend,
                    is_prerak_attend: activity?.data?.is_prerak_attend,
                    no_prerak_attend: activity?.data?.no_prerak_attend,
                    farmer_commitment: activity?.data?.farmer_commitment,
                    weight_unit_id: activity?.data?.weight_unit_id,
                    prerak_commitment: activity?.data?.prerak_commitment,
                    retailer_commitment: activity?.data?.retailer_commitment,
                    group_meeting_farmer_phone: activity?.data?.group_meeting_farmer_phone,
                    remark: activity?.data?.remark,
                    latitude: activity?.data?.latitude,
                    longitude: activity?.data?.longitude,
                    group_meeting_farmer_image: group_meeting_farmer_image,
                    group_meeting_image: group_meeting_image,
                  }
                }
              }

              activityArray.push(objRequest);
            }


            resolve(activityArray);
          }
        } else {
          resolve(activityArray);
        }
      });
    });

    const images = new Promise((resolve) => {
      SyncServices.getLocalActivities("is_synced", "false").then(activities => {
        let activity_images = [];
        //For Images
        if (activities != null || activities?.length > 0) {
          for (let i = 0; i < activities.length; i++) {
            const activity = activities[i];
            for (let j = 0; j < activity?.data?.activity_images?.length; j++) {
              const objImage = activity?.data?.activity_images[j];
              if (objImage.image_id === 0) {
                activity_images.push(objImage?.file);
              }
            }
          }

          //Utilities.LogPrint("Images", activity_images);
          resolve(activity_images);
        } else {
          resolve(activity_images);
        }
      });
    });

    const groupMeetingImages = new Promise((resolve) => {
      SyncServices.getLocalActivities("is_synced", "false").then(activities => {
        let activity_images = [];
        if (activities != null || activities?.length > 0) {
          //For Images
          if (activities != null || activities?.length > 0) {
            for (let i = 0; i < activities.length; i++) {
              const activity = activities[i];
              if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                for (let j = 0; j < activity?.data?.group_meeting_image?.length; j++) {
                  const objImage = activity?.data?.group_meeting_image[j];
                  activity_images.push(objImage?.file);
                }
              }
            }
          }
          //Utilities.LogPrint("Images", activity_images);
          resolve(activity_images);
        } else {
          resolve(activity_images);
        }
      });
    });

    const groupMeetingFarmerImages = new Promise((resolve) => {
      SyncServices.getLocalActivities("is_synced", "false").then(activities => {
        let activity_images = [];
        if (activities != null || activities?.length > 0) {
          //For Images
          if (activities != null || activities?.length > 0) {
            for (let i = 0; i < activities.length; i++) {
              const activity = activities[i];
              if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                for (let j = 0; j < activity?.data?.farmerNumbersImageFiles?.length; j++) {
                  const objImage = activity?.data?.farmerNumbersImageFiles[j];
                  activity_images.push(objImage?.file);
                }
              }
            }
          }
          //Utilities.LogPrint("Images", activity_images);
          resolve(activity_images);
        } else {
          resolve(activity_images);
        }
      });
    });

    Promise.all([activities, images, groupMeetingImages, groupMeetingFarmerImages]).then((value) => {
      const activityArray = value[0];
      const activity_images = value[1];
      const group_meeting_image = value[2];
      const group_meeting_farmer_image = value[3];

      //Utilities.LogPrint("Activity", activityArray);
      //Utilities.LogPrint("Activity Image", activity_images);
      //Utilities.LogPrint("Activity Group Image", group_meeting_image);
      //Utilities.LogPrint("Activity Farmer Image", group_meeting_farmer_image);

      const lastSyncDate = localStorage.getItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE);
      Utilities.LogPrint("LastSyncDate", lastSyncDate);
      const formData = new FormData();
      let lst_sync = [
        {
          action: SYNC_SERVICE.ACTION_ADD_ACTIVITY,
          last_sync_date: lastSyncDate,
          //last_sync_date: "",
          data: activityArray
        }
      ]
      formData.append("lst_sync", JSON.stringify(lst_sync));

      for (let i = 0; i < activity_images.length; i++) {
        formData.append("activity_image", activity_images[i]);
      }
      for (let i = 0; i < group_meeting_image.length; i++) {
        formData.append("group_meeting_image", group_meeting_image[i]);
      }
      for (let i = 0; i < group_meeting_farmer_image.length; i++) {
        formData.append("group_meeting_farmer_image", group_meeting_farmer_image[i]);
      }

      this.setState({ tableName: SYNC_SERVICE.ACTIVITY_TABLE });
      try {
        ApiServices.syncActivityData(formData)
          .then(async response => {
            //this.setState({ isSyncLoading: false, tableName: SYNC_SERVICE.ACTIVITY_TABLE });
            Utilities.LogPrint("API_DATA syncData: ---->", response);
            if (response.success) {
              let data = response.data;
              if (data != null) {
                let KEY = SYNC_SERVICE.ACTION_ADD_ACTIVITY;
                const activitiesData = data.find(item => item.action === KEY);
                Utilities.LogPrint("activitiesData Data", activitiesData.data);
                localStorage.setItem(SYNC_SERVICE.LAST_SYNC_DATE, activitiesData?.last_sync_date);
                localStorage.setItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE, activitiesData?.last_sync_date);

                for (let i = 0; i < activitiesData?.data.length; i++) {
                  const activity = activitiesData?.data[i];
                  if (activity !== null && data !== undefined) {


                    // FOR INDIVIDUAL_VISIT & SAMPLE_DISTRIBUTION
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT ||
                      activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {

                      SyncServices.updateActivityWithServer(activity, "true");

                      //*** Convert Image To Byte Array (For Showing Image In Local) ***//
                      // if (activity?.data?.activity_images.length > 0) {
                      //   for (const element of activity?.data?.activity_images) {
                      //     const byteArray = await Utilities.getImageBytesFromUrl(element.image_url);
                      //     Utilities.LogPrint("Update byteArray", byteArray);
                      //     if (byteArray) {
                      //       element.byteArray = byteArray;
                      //     }
                      //   }
                      //   //Utilities.LogPrint("UPDATE Server With Images=== ", activity);
                      //   SyncServices.updateActivityWithServer(activity, "true");
                      // } else {
                      //   //Utilities.LogPrint("UPDATE Server === ", activity);
                      //   SyncServices.updateActivityWithServer(activity, "true");
                      // }
                    }


                    // FOR GROUP_MEETING
                    if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                      Utilities.LogPrint("GroupMeetingActivity ", activity);
                      try {
                        activity.data.group_meeting_farmer_phone = activity.group_meeting_farmer_phone;
                      } catch (error) {
                        Utilities.LogPrint("GroupMeetingActivity ", error);
                      }
                      if (activity.group_meeting_farmer_image.length > 0) {
                        // for (const element of activity.group_meeting_farmer_image) {
                        //   const byteArray = await Utilities.getImageBytesFromUrl(element.image_url);
                        //   Utilities.LogPrint("Update byteArray", byteArray);
                        //   if (byteArray) {
                        //     element.byteArray = byteArray;
                        //   }
                        // }
                        if (activity.group_meeting_image.length > 0) {
                          // for (const element of activity.group_meeting_image) {
                          //   const byteArray = await Utilities.getImageBytesFromUrl(element.image_url);
                          //   Utilities.LogPrint("Update byteArray", byteArray);
                          //   if (byteArray) {
                          //     element.byteArray = byteArray;
                          //   }
                          // }
                          activity.data.prerak_commitment = activity.prerak_commitment;
                          activity.data.retailer_commitment = activity.retailer_commitment;
                          activity.data.group_meeting_farmer_image = activity.group_meeting_farmer_image;
                          activity.data.group_meeting_image = activity.group_meeting_image;
                          SyncServices.updateActivityWithServer(activity, "true");
                        } else {
                          activity.data.prerak_commitment = activity.prerak_commitment;
                          activity.data.retailer_commitment = activity.retailer_commitment;
                          activity.data.group_meeting_farmer_image = activity.group_meeting_farmer_image;
                          activity.data.group_meeting_image = activity.group_meeting_image;
                          SyncServices.updateActivityWithServer(activity, "true");
                        }
                      } else if (activity.group_meeting_image.length > 0) {
                        // for (const element of activity.group_meeting_image) {
                        //   const byteArray = await Utilities.getImageBytesFromUrl(element.image_url);
                        //   Utilities.LogPrint("Update byteArray", byteArray);
                        //   if (byteArray) {
                        //     element.byteArray = byteArray;
                        //   }
                        // }
                        activity.data.prerak_commitment = activity.prerak_commitment;
                        activity.data.retailer_commitment = activity.retailer_commitment;
                        activity.data.group_meeting_farmer_image = activity.group_meeting_farmer_image;
                        activity.data.group_meeting_image = activity.group_meeting_image;
                        SyncServices.updateActivityWithServer(activity, "true");
                      } else {
                        SyncServices.updateActivityWithServer(activity, "true");
                      }
                    }


                    // FOR SAMPLE TO SALE
                    if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                      SyncServices.updateActivityWithServer(activity, "true");
                    }
                  }

                }

                this.setState({ isSyncLoading: false, tableName: SYNC_SERVICE.ACTIVITY_TABLE });
                const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
                if (showBulkUpload?.view) {
                  this.getFDOActivities();
                  //this.getFdoActivityByDateApi();
                } else {
                  this.getActivities();
                }

              }
            } else {
              Utilities.LogPrint("Status", response.message);
              if (response.message === COMMON.TOKEN_EXPIRED) {
                Utilities.tokenExpiredRedirectToLogin();
              }
            }
          }).catch(error => {
            this.setState({ isSyncLoading: false, tableName: SYNC_SERVICE.ACTIVITY_TABLE });
            Utilities.LogPrint("Status-Catch", error);
          });
      } catch (error) {
        this.setState({ isSyncLoading: false, tableName: SYNC_SERVICE.ACTIVITY_TABLE });
      }
    });
  }


  activityTag(number) {
    if (number <= 9999) { number = ("0000" + number).slice(-5); }
    return number;
  }

  //OFFLINE ACTIVITIES DATA
  getActivities = () => {
    this.setState({ isLoading: true });
    SyncServices.getActivities().then(data => {
      this.setState({ isLoading: false });
      //Utilities.LogPrint("LOCAL DATA", data);
      if (data !== undefined && data !== null) {
        let activities = [];
        let todayData = {
          IV: 0,
          SD: 0,
          GM: 0,
          S2S: 0,
        };
        for (let i = 0; i < data?.todayActivities.length; i++) {
          const activity = data?.todayActivities[i];

          // For Activity Count
          if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT) {
            todayData.IV = todayData.IV + 1;
          } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            todayData.SD = todayData.SD + 1;
          } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            todayData.GM = todayData.GM + 1;
          } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            todayData.S2S = todayData.S2S + 1;
          }

          let activity_type_name, activity_tag, dataObj = null;

          // For Today Activity
          if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
            activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_FARMER;
            activity_tag = `IVF${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id > 0) {
            activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_RETAILER;
            activity_tag = `IVR${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            activity_type_name = HomeActivityType.SAMPLE_DISTRIBUTION;
            activity_tag = `SD${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            activity_type_name = HomeActivityType.GROUP_MEET;
            activity_tag = `GM${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            //activity_type_name = HomeActivityType.SAMPLE_TO_SALE;
            activity_type_name = Utilities.getActivityStageName(activity.stage_id);
            activity_tag = `S2S${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;
            dataObj = activity?.data;
          }

          let activityObj = {
            key: activity?.key,
            activity_id: activity?.activity_id,
            activity_type_id: activity.activity_type_id,
            activity_type_name: activity_type_name,
            assigned_user_id: activity.assigned_user_id,
            user_id: activity.user_id,
            activity_tag: activity_tag,
            activity_status_id: activity.activity_status_id,
            crop_id: activity?.crop_id,
            hybrid_id: activity?.hybrid_id,
            village_id: activity?.village_id,
            crop_name: DataProvider.getInstance().getCropNameById(activity?.crop_id),
            hybrid_name: DataProvider.getInstance().getHybridNameById(activity?.hybrid_id),
            village_name: DataProvider.getInstance().getVillageNameById(activity?.village_id),
            krishak_id: activity?.krishak_id,
            retailer_id: activity?.retailer_id,
            stage_id: activity?.stage_id ? activity?.stage_id : 0,
            stage: activity?.stage,
            reporting_mobile: activity?.reporting_mobile,
            data: dataObj
          }

          activities.push(activityObj);
        }

        // For Pending Activities
        let pendingActivities = [];
        for (let i = 0; i < data?.pendingActivities.length; i++) {
          const activity = data?.pendingActivities[i];

          let activity_type_name, activity_tag, dataObj = null;
          // For Today Activity
          if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity?.retailer_id === 0) {
            activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_FARMER;
            activity_tag = `IVF${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity?.retailer_id > 0) {
            activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_RETAILER;
            activity_tag = `IVR${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            activity_type_name = HomeActivityType.SAMPLE_DISTRIBUTION;
            activity_tag = `SD${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            activity_type_name = HomeActivityType.GROUP_MEET;
            activity_tag = `GM${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;

          } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            //activity_type_name = HomeActivityType.SAMPLE_TO_SALE;
            activity_type_name = Utilities.getActivityStageName(activity.stage_id);
            activity_tag = `S2S${activity?.activity_id > 0 ? this.activityTag(activity.activity_id) : ''}`;
            dataObj = activity?.data;
          }

          let activityObj = {
            key: activity?.key,
            activity_id: activity?.activity_id,
            activity_type_id: activity.activity_type_id,
            activity_type_name: activity_type_name,
            assigned_user_id: activity.assigned_user_id,
            user_id: activity.user_id,
            activity_tag: activity_tag,
            activity_status_id: activity.activity_status_id,
            crop_id: activity?.crop_id,
            hybrid_id: activity?.hybrid_id,
            village_id: activity?.village_id,
            crop_name: DataProvider.getInstance().getCropNameById(activity?.crop_id),
            hybrid_name: DataProvider.getInstance().getHybridNameById(activity?.hybrid_id),
            village_name: DataProvider.getInstance().getVillageNameById(activity?.village_id),
            krishak_id: activity?.krishak_id,
            retailer_id: activity?.retailer_id,
            stage_id: activity?.stage_id ? activity?.stage_id : 0,
            stage: activity?.stage,
            reporting_mobile: activity?.reporting_mobile,
            data: dataObj
          }
          pendingActivities.push(activityObj);
        }
        this.setState({
          todayData: todayData,
          activityList: activities,
          pendingActivityList: pendingActivities,
        })
      }
    });
  }

  //OFFLINE LOGIC
  syncAllKrishakData = async () => {
    this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
    SyncServices.getKrishakFromDatabase("is_synced", "false").then(async data => {
      if (data && data.length > 0) {
        this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
        let krishaksForUpdate = [];
        const formData = new FormData();
        const lastSyncDate = localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE);

        for (var i = 0; i < data.length; i++) {
          const krishak = data[i].data;

          var yourdate = krishak.dob.split("/").reverse();
          var tmp = yourdate[2];
          yourdate[2] = yourdate[1];
          yourdate[1] = tmp;
          yourdate = yourdate.join("-");
          yourdate = yourdate.replace("--", "")

          if (krishak.prerak_name_phone?.krishak_id !== undefined) {
            krishak.prerak_name_phone = krishak.prerak_name_phone.krishak_id.toString();
          } else {
            krishak.prerak_name_phone = "[]";
          }
          krishak.dob = yourdate;

          krishaksForUpdate.push(krishak);
          for (var j = 0; j < krishak?.imagesFiles?.length; j++) {
            formData.append("krishak_image", krishak.imagesFiles[j].file);

          }
          for (var k = 0; k < krishak.farmer_mobile_images_files?.length; k++) {
            formData.append("krishak_fellow_farmer_image", krishak.farmer_mobile_images_files[k].file);

          }
        }
        let lst_sync = [
          {
            action: "krishak",
            last_sync_date: lastSyncDate,
            data: krishaksForUpdate
          }
        ]
        formData.append("lst_sync", JSON.stringify(lst_sync));

        try {
          ApiServices.syncKrishakData(formData)
            .then(async response => {
              //Utilities.LogPrint("API_DATA syncData: ---->", response);
              this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
              this.getAllKrishak();
              if (response.success) {
                Utilities.LogPrint("Status", response.data);
                let data = response.data;
                let KEY = SYNC_SERVICE.ACTION_KRISHAK;
                var findKrishakActionData = data.find(item => item.action === KEY);

                for (let i = 0; i < findKrishakActionData.data.length; i++) {
                  let krishak = findKrishakActionData.data[i];
                  SyncServices.addKrishakToDatabase(
                    krishak,
                    krishak.phone,
                    krishak.is_prerak === 1 ? "true" : "false",
                    krishak.krishak_id.toString(),
                    "0"
                  );
                }
              } else {
                Utilities.LogPrint("Status", response.message);
              }
            }).catch(error => {
              this.getAllKrishak();
              this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
              Utilities.LogPrint("Status-Catch", error);
            });
        } catch (error) {
          this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
          this.getAllKrishak();
          Utilities.LogPrint("Status-Error", error);
        }

      } else {
        this.getAllKrishak();
      }
    });
  }

  syncAllMasterData = () => {
    //const { allMasterKeys } = this.state;
    const formData = new FormData();
    let lst_sync = [];
    // const lastSyncDate = localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE);
    const lastSyncDate = "2020-01-01 00:00:00";
    for (var i = 0; i < allMasterKeys.length; i++) {
      lst_sync.push({
        action: allMasterKeys[i],
        last_sync_date: lastSyncDate,
        data: []
      })
    }
    formData.append("lst_sync", JSON.stringify(lst_sync));
    this.setState({ isSyncLoading: true, tableName: SYNC_SERVICE.MASTER_TABLE });
    try {
      ApiServices.syncData(formData)
        .then(async response => {
          //Utilities.LogPrint("allMasterDataResponse", response);
          this.setState({ tableName: SYNC_SERVICE.MASTER_TABLE });
          if (response.success) {
            //Utilities.LogPrint("Status", response.data);
            let data = response.data;

            for (let j = 0; j < allMasterKeys.length; j++) {
              var masterData = data.find(item => item.action === allMasterKeys[j]);
              var masterArray = masterData.data;
              if (masterArray.length > 0) {
                //Utilities.LogPrint('AllMasterData', masterArray);
                //var dataArray = await SyncServices.getDataFromDatabase(allMasterKeys[j], SYNC_SERVICE.MASTER_TABLE)

                //Utilities.LogPrint('AllMasterDataArray', dataArray);
                SyncServices.addMasterToDatabase(masterArray, allMasterKeys[j]);

                // let arrayToAdd = dataArray.slice();
                // if (dataArray === undefined || dataArray === null || dataArray.length === 0) {
                //   SyncServices.addMasterToDatabase(masterArray, allMasterKeys[j]);
                // } else {
                //   for (var k = 0; k < masterArray.length; k++) {
                //     let dataObject = masterArray[k];
                //     var presentObject = dataArray.find(item => item.created_at === dataObject.created_at);
                //     var presentIndex = dataArray.findIndex(item => item.created_at === dataObject.created_at);
                //     if (dataObject.modified_at !== presentObject.modified_at) {
                //       arrayToAdd[presentIndex] = dataObject;
                //       //Utilities.LogPrint('UpdatedObject', dataObject);
                //     }
                //     //Utilities.LogPrint('presentObject', presentObject);
                //     //Utilities.LogPrint('presentIndex', presentIndex);
                //   }
                //   SyncServices.addMasterToDatabase(arrayToAdd, allMasterKeys[j]);
                // }
              }
            }

            this.syncAllKrishakData();
            await DataProvider.getInstance().fetchMasterData();
            //this.getActivityFDOApi();
            //this.syncAllActivityData();

            if (this.state.fdoList.length === 0) {
              this.getActivityFDOApi();
            }

          } else {
            //Utilities.LogPrint("Status", response.message);
            if (response.message === COMMON.TOKEN_EXPIRED) {
              Utilities.tokenExpiredRedirectToLogin();
            }
          }
        }).catch(error => {
          this.syncAllKrishakData();
          this.setState({ tableName: SYNC_SERVICE.MASTER_TABLE });
          Utilities.LogPrint("Status-Catch", error);
        });
    } catch (error) {
      this.setState({ tableName: SYNC_SERVICE.MASTER_TABLE });
      this.syncAllKrishakData();
      Utilities.LogPrint("Status-Error", error);
    }
  }

  getAllKrishak = async () => {

    const formData = new FormData();

    const lastSyncDate = localStorage.getItem("lastSyncDate");
    let lst_sync = [
      {
        action: "krishak",
        last_sync_date: lastSyncDate,
        data: []
      }
    ]
    formData.append("lst_sync", JSON.stringify(lst_sync));

    this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
    try {
      ApiServices.syncKrishakData(formData)
        .then(async response => {
          this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
          this.syncAllActivityData();
          if (response.success) {
            let data = response.data;
            let KEY = SYNC_SERVICE.ACTION_KRISHAK;
            var findKrishakActionData = data.find(item => item.action === KEY);

            for (let i = 0; i < findKrishakActionData.data.length; i++) {
              let krishak = findKrishakActionData.data[i];
              SyncServices.addKrishakToDatabase(
                krishak,
                krishak.phone,
                krishak.is_prerak === 1 ? "true" : "false",
                krishak.krishak_id.toString(),
                "0"
              );
            }
          } else {
            //Utilities.LogPrint("Status", response.message);
          }
        }).catch(error => {
          this.syncAllActivityData();
          this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
        });
    } catch (error) {
      this.syncAllActivityData();
      this.setState({ tableName: SYNC_SERVICE.KRISHAK_TABLE });
    }
  }

  //Api Calls
  getActivityFDOApi = () => {
    //this.setState({ isLoading: true });

    SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(users => {
      //Utilities.LogPrint("users:", users);
      //this.setState({ isLoading: false });
      if (users !== undefined && users !== null && users?.length > 0) {
        const session = AuthService.getSession();
        var user = users?.find(item => item.user_id === session?.user.user_id);
        if (user) {
          user['name'] = "Self"
        }

        const firstLevelUsers = users.filter(item => (item.server_employee_id === session?.user.server_employee_id
          || item.server_manager_id === session?.user.server_employee_id) && item.is_active === 1);


        //Utilities.LogPrint('#fdoListArray', users);
        this.setState({ fdoList: firstLevelUsers, isFDO: users?.length === 1 });

        if (users?.length === 1) {
          this.setState({ selectedFDO: user });
        }
      }
    });

    // try {
    //   ApiServices.getActivityFDO()
    //     .then(response => {
    //       var status = response.success
    //       if (status) {
    //         Utilities.LogPrint("getActivityFDOApi", response.data.data);
    //         const userPrefrences = JSON.parse(localStorage.getItem(API_CONSTANTS.USER_PREFRENCES));
    //         let fdoListArray = response.data.data;
    //         // grab the Array item which matchs the id "2"
    //         var item = fdoListArray.find(item => item.user_id === userPrefrences.user_id);
    //         item['name'] = "Self"
    //         this.setState({ fdoList: fdoListArray, isLoading: false })
    //       }
    //       else {
    //         this.setState({ isLoading: false });
    //       }
    //     })
    //     .catch(error => {
    //       Utilities.LogPrint("getActivityFDOApi-Catch", error);
    //     });
    // }
    // catch (error) {
    //   //this.props.loaderCallback(false);
    //   Utilities.LogPrint("getActivityFDOApi-Error", error);
    // }
  }

  // _getTodayActivityApi = () => {
  //   this.setState({ isLoading: true });
  //   const userPrefrences = AuthService.getSession()?.user;
  //   var params = JSON.stringify({
  //     toDayDate: Utilities.getCurrentDate(),
  //     assigned_user_id: userPrefrences.user_id
  //   });
  //   try {
  //     ApiServices.getTodayActivity(params)
  //       .then(response => {
  //         var status = response.success
  //         if (status) {
  //           Utilities.LogPrint("_getTodayActivityApi", response.data.data);
  //           let isCheck = (response.data.data.start_time === null) ? false : true;
  //           //let mTodayActivity = response.data.data.to_day_activities.map(v => ({ ...v, start_time: response.data.data.start_time, end_time: response.data.data.end_time }))
  //           //let mPendingActivity = response.data.data.pending_activities.map(v => ({ ...v, start_time: response.data.data.start_time, end_time: response.data.data.end_time }))
  //           this.setState({
  //             //todayData: response.data.data,
  //             startTime: response.data.data.start_time,
  //             endTime: response.data.data.end_time,
  //             isCheckIn: isCheck,
  //             //activityList: mTodayActivity,
  //             //pendingActivityList: mPendingActivity,
  //             isLoading: false
  //           });
  //         }
  //         else {
  //           this.setState({ isLoading: false });
  //         }
  //       })
  //       .catch(error => {
  //         Utilities.LogPrint("_getTodayActivityApi-catch", error);
  //       });
  //   }
  //   catch (error) {
  //     Utilities.LogPrint("_getTodayActivityApi-error", error);
  //   }
  // }

  getFdoActivityByDateApi = () => {
    var params = JSON.stringify({
      date: Utilities.getCurrentDate(),
      //assigned_user_id: userPrefrences.user_id
    });

    this.setState({ isLoading: true });
    try {
      ApiServices.getFdoActivityByDate(params)
        .then(response => {
          this.setState({ isLoading: false });
          var status = response.success
          if (status) {
            const session = AuthService.getSession();
            let fdoListArray = response.data.fdo;
            var item = fdoListArray.find(item => item.user_id === session?.user.user_id);
            if (item) {
              item['name'] = "Self"
            }

            let finalData = response.data;
            finalData['fdo'] = fdoListArray

            Utilities.LogPrint("DATA", finalData);

            //let isCheck = (response.data.start_time === null) ? false : true;
            this.setState({
              todayData: finalData,
              //startTime: response.data.start_time,
              //endTime: response.data.end_time,
              //isCheckIn: isCheck,
              isLoading: false
            });
          }
          else {
            this.setState({ isLoading: false });
          }
        })
        .catch(error => {
          Utilities.LogPrint("getFdoActivityByDateApi-catch", error);
        });
    }
    catch (error) {
      //this.props.loaderCallback(false);
      Utilities.LogPrint("getFdoActivityByDateApi-error", error);
    }
  }

  getKrishakByReferenceIdApi = () => {
    const { selectedActivityItem, startTime, endTime } = this.state;

    if (startTime !== null && endTime === null) {
      if (selectedActivityItem.retailer_id === 1) {
        const retailers = DataProvider.getInstance().getRetailers();
        Utilities.LogPrint("retailers", retailers);
        if (retailers !== null) {
          let retailer = retailers.find(item => item.phone === this.state.mobileNumber);
          if (retailer) {
            Utilities.LogPrint("retailer", retailer);
            this.setState({ retailerInfo: retailer }, () => {
              this.handleListClick(selectedActivityItem);
            });
          } else {
            toast.info(COMMON.RETAILER_NOT_FOUND);
          }
        } else {
          toast.info(COMMON.RETAILER_NOT_FOUND);
        }

      } else {

        SyncServices.findKrishakFromDatabase("key", this.state.mobileNumber).then(data => {
          Utilities.LogPrint("getKrishakFromDatabase ==", data);
          if (data) {

            if (data.is_active === undefined || data.is_active === null || data.is_active === 1 || data.is_active === true) {
              this.setState({ krishakInfo: data }, () => {
                this.handleListClick(selectedActivityItem);
              });
            } else {
              toast.info(COMMON.KRISHAK_NOT_FOUND);
            }
          } else {
            toast.info(COMMON.KRISHAK_NOT_FOUND);
          }
        });
      }
    } else {
      toast.info(COMMON.START_DAY_MESSAGE);
    }
  }

  //For Edit Plan Api
  _getActivityByIdApi = (item) => {
    Utilities.LogPrint("@selected Card Item", item);
    var params = JSON.stringify({
      activity_id: item.activity_id
    });
    try {
      ApiServices.getActivityById(params)
        .then(response => {
          var status = response.success
          if (status) {
            const { fdoList } = this.state;
            let activity = response.data;

            //Find index of specific object using findIndex method.
            let fdoIndex = fdoList.findIndex((obj => obj.user_id === activity.assigned_user_id));
            let activityObj = {
              isEdit: true,
              editActivityId: item.activity_id,
              selectedActivity: item.activity_type_name,
              selectedActivityId: item.activity_type_id,
              selectedFDO: fdoList[fdoIndex],
              cropId: activity.crop.crop_id,
              hybrid: { value: activity.hybrid.hybrid_id, label: activity.hybrid.season_name },
              village: { value: activity.village.village_id, label: activity.village.village_name }
            }

            this.props.history.push({
              pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
              state: {
                isLoading: false,
                selectedActivity: item.activity_type_name,
                selectedActivityId: item.activity_type_id,
                editActivity: activityObj
              }
            });
          }
          else {
            this.setState({
              isLoading: false,
            })
          }
        })
        .catch(error => {
          Utilities.LogPrint("getActivityById-Catch", error);
        });
    }
    catch (error) {
      Utilities.LogPrint("getActivityById-Error", error);
    }
  }


  _handleChange = (e) => {
    if (this.searchTimerHandle != null) {
      clearTimeout(this.searchTimerHandle);
    }
    let value = e.target.value;
    this.searchTimerHandle = setTimeout(() => {
      this.setState({ searchedValue: value })
    }, 1000);
  }

  verifyNumber = event => {
    const { value, maxLength } = event.target;
    const mobileNumber = value.slice(0, maxLength);
    // const val = event.target.value;
    // const maxLength = 10;
    // const mobileNo = val < maxLength ? val : parseInt(val.toString().substring(0, maxLength));

    this.setState({ mobileNumber });

    if (this.state.isHost && mobileNumber.length === 10) {
      this.getKrishakDetails(mobileNumber);
    }
  }

  getKrishakDetails = (mobileNumber) => {
    SyncServices.findKrishakFromDatabase("key", mobileNumber).then(data => {
      Utilities.LogPrint("getKrishakFromDatabase ==", data);
      if (data) {
        if (data.is_active === undefined || data.is_active === null || data.is_active === 1 || data.is_active === true) {
          this.setState({
            krishakInfo: data,
            hostFarmerName: data?.name
          });
        }
      } else {
        this.setState({ hostFarmerName: '' })
      }
    });
  }

  _handlePendingActivities = () => {
    this.props.history.push(ALL_ROUTES.MANAGER_HOME_TODAY_ROUTE);
  }

  _selectFDO = (obj, e) => {
    e.preventDefault();
    this.setState({
      selectedFDO: obj,
    }, () => {
      const { selectedActivity } = this.state;
      if (selectedActivity !== HomeActivityType.INDIVIDUAL_VISIT_FARMER && selectedActivity !== HomeActivityType.INDIVIDUAL_VISIT_RETAILER) {
        this._handleAddActivity(this.state.selectedActivity);
      }
    })
  }

  selectActivity = (selectedActivity) => {
    this.setState({
      selectedActivity: selectedActivity,
    });
  }

  _handleAddActivity = (selectedActivity) => {

    const { startTime, endTime, selectedFDO } = this.state;
    if (startTime !== null && endTime === null) {
      this.setState({
        selectedActivity: selectedActivity,
      });
      switch (selectedActivity) {
        case HomeActivityType.INDIVIDUAL_VISIT_FARMER:
          this.props.history.push({
            pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
            state: { selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_FARMER, selectedActivityId: 1, selectedFDO: selectedFDO }
          })
          break;
        case HomeActivityType.INDIVIDUAL_VISIT_RETAILER:
          this.props.history.push({
            pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
            state: { selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_RETAILER, selectedActivityId: 1, selectedFDO: selectedFDO }
          })
          break;
        case HomeActivityType.SAMPLE_DISTRIBUTION:
          this.props.history.push({
            pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
            state: { selectedActivity: HomeActivityType.SAMPLE_DISTRIBUTION, selectedActivityId: 2, selectedFDO: selectedFDO }
          });
          break;
        case HomeActivityType.GROUP_MEET:
          this.props.history.push({
            pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
            state: { selectedActivity: HomeActivityType.GROUP_MEET, selectedActivityId: 3, selectedFDO: selectedFDO }
          });
          break;
        case HomeActivityType.SAMPLE_TO_SALE:
          this.props.history.push({
            pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
            state: { selectedActivity: HomeActivityType.SAMPLE_TO_SALE, selectedActivityId: 4, selectedFDO: selectedFDO }
          })
          break;
        default:
          break;
      }
    } else {
      toast.info(COMMON.START_DAY_MESSAGE);
    }
  }

  getActivityItem = (item) => {
    Utilities.LogPrint("getActivityItem", item);
    const { startTime, endTime } = this.state;
    if (startTime !== null && endTime === null) {

      this.setState({
        selectedActivityItem: item
      });

      if (item.activity_status_id === ActivityStatusType.TO_START && item.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
        this.handleListClick(item);
        return;

      } else if (item.activity_status_id === ActivityStatusType.TO_RESUBMIT && item.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
        this.handleListClick(item);
        return;

      } else if (item.activity_status_id === ActivityStatusType.TO_RESUBMIT) {
        this.handleListClick(item);
        return;
      }

      // For View Activity Details
      if (item.activity_status_id === ActivityStatusType.PENDING_REVIEW ||
        item.activity_status_id === ActivityStatusType.COMPLETED) {

        if (item.activity_type_id === ActivityType.GROUP_MEETING) {
          this.props.history.push({
            pathname: ALL_ROUTES.GROUP_MEETING_VIEW_ROUTE,
            state: { data: item }
          });

        } else if (item.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
          this.props.history.push({
            pathname: ALL_ROUTES.SAMPLE_TO_SALE_VIEW_ROUTE,
            state: { data: item }
          });
        } else {
          this.props.history.push({
            pathname: ALL_ROUTES.ACTIVITY_DETAILS_ROUTE,
            state: { activity: item }
          });
        }
        return;
      }

    } else {
      toast.info('Start the day to make any changes.');
    }

    // if (item.activity_status_id === ActivityStatusType.PENDING_REVIEW ||
    //   item.activity_status_id === ActivityStatusType.COMPLETED) {
    //   this.props.history.push({
    //     pathname: ALL_ROUTES.ACTIVITY_DETAILS_ROUTE,
    //     state: { activity: item, isFarmer: true }
    //   });
    //   return;
    // }


  }

  // goToGroupMeeting = () => {
  //   const { selectedActivityItem, startTime, endTime } = this.state;

  //   if (startTime !== null || endTime === "") {
  //     this.props.history.push({
  //       pathname: ALL_ROUTES.ADD_GROUP_MEET_ROUTE,
  //       state: { data: selectedActivityItem, krishakInfo: null }
  //     });
  //   } else {
  //     toast.info(COMMON.START_DAY_MESSAGE);
  //   }
  // }

  goToGroupMeeting = () => {
    const { selectedActivityItem, mobileNumber, hostFarmerName, startTime, endTime, krishakInfo } = this.state;

    const hostInfo = {
      krishak_id: krishakInfo ? krishakInfo.krishak_id : 0,
      phone: mobileNumber,
      name: hostFarmerName,
    }

    if (startTime !== null && endTime === null) {
      this.props.history.push({
        pathname: ALL_ROUTES.ADD_GROUP_MEET_ROUTE,
        state: { data: selectedActivityItem, krishakInfo: hostInfo }
      });
    } else {
      toast.info(COMMON.START_DAY_MESSAGE);
    }
  }

  handleDelete = (e, item) => {
    const { startTime, endTime } = this.state;
    e.preventDefault();
    if (startTime !== null && endTime === null) {
      Utilities.LogPrint("Delete", item);
      SyncServices.updateDeleteActivity(item.key, "false");
      this.getActivities();

      // If User Online
      if (Utilities.isNetworkConnected()) {
        var params = JSON.stringify({
          activity_id: item.activity_id,
          is_active: 0
        });
        try {
          ApiServices.deleteActivity(params)
            .then(response => {
              this.setState({ isLoading: false });
              var status = response.success
              if (status) {
                //Utilities.LogPrint("deleteActivity", response.message);
                SyncServices.updateDeleteActivity(item.key, "true");
              }
            })
            .catch(error => {
              Utilities.LogPrint("deleteActivity-catch", error);
            });
        }
        catch (error) {
          Utilities.LogPrint("deleteActivity-error", error);
        }
      }

    } else {
      toast.info(COMMON.START_DAY_MESSAGE);
    }
  }

  handleActivitiesEdit = (e, item) => {
    const { startTime, endTime } = this.state;
    e.preventDefault();
    Utilities.LogPrint("handleActivitiesEdit", item);

    if (startTime !== null && endTime === null) {
      //With API
      //this._getActivityByIdApi(item);

      this.props.history.push({
        pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
        state: {
          isLoading: false,
          selectedActivity: item.activity_type_name,
          selectedActivityId: item.activity_type_id,
          editActivity: item
        }
      });

    } else {
      toast.info(COMMON.START_DAY_MESSAGE);
    }
  }

  handleListClick = (activity) => {
    //Utilities.LogPrint("CARD INFO", activity);
    const { krishakInfo, retailerInfo } = this.state;

    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
      this.props.history.push({
        pathname: ALL_ROUTES.ADD_FARMER_ROUTE,
        state: { data: activity, isFarmer: true, krishakInfo: krishakInfo }
      });

    } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id > 0) {
      this.props.history.push({
        pathname: ALL_ROUTES.ADD_FARMER_ROUTE,
        state: { data: activity, retailerInfo: retailerInfo }
      });

    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
      this.props.history.push({
        pathname: ALL_ROUTES.ADD_SAMPLE_DISTRIBUTION_ROUTE,
        state: { activity: activity, krishakInfo: krishakInfo }
      });

    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
      this.props.history.push({
        pathname: ALL_ROUTES.ADD_GROUP_MEET_ROUTE,
        state: { data: activity, krishakInfo: krishakInfo }
      });

    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
      activity.isEdit = false;
      this.props.history.push({
        pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
        state: { activity: activity, krishakInfo: krishakInfo }
      });
    }
  }



  handleManagerClick = (item) => {
    //Utilities.LogPrint("ManagerListClick", item);

    const { startTime, endTime } = this.state;
    if (startTime !== null && endTime === null) {
      this.props.history.push({
        pathname: ALL_ROUTES.MANAGER_FDO_DETAIL_ROUTE,
        state: { data: item }
      })

    } else {
      toast.info('Start the day to make any changes.');
    }
    //MANAGER_FDO_DETAIL_ROUTE

  }

  handleStartEndDay(e) {

    e.preventDefault();
    //Utilities.LogPrint("handleStartEndDay", this.state.isCheckIn);
    this.addUserStartEndDayApi()
    //this.setState({ isCheckIn: !this.state.isCheckIn })

  }

  handleSyncLoading = (loading, tableName) => {
    Utilities.LogPrint("handleSyncLoading", loading + tableName)
    this.setState({ isSyncLoading: loading, tableName })
  }

  goToBulkUpload = () => {
    this.props.history.push(ALL_ROUTES.BULK_UPLOAD_ROUTE);
  }

  handleSync = () => {
    const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
    if (showBulkUpload?.view) {
      this.getFDOActivities();
    } else {
      this.getActivities();
    }

    if (this.state.fdoList.length === 0) {
      this.getActivityFDOApi();
    }
  }

  render() {
    const { todayData, isSyncLoading, startTime, endTime, userName, fdoList, searchedValue, mobileNumber, isCheckIn, activityList, pendingActivityList, isLoading, selectedActivity, hostFarmerName } = this.state;

    const showAddIndividualVisit = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_INDIVIDUAL_VISIT);
    const showAddSampleDistribution = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_SAMPLE_DISTRIBUTION);
    const showAddGroupMeet = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_GROUP_MEETING);
    const showAddSampleToSale = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_SAMPLE_TO_SALE);
    const showBulkUpload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.BULK_UPLOAD);
    //const showStartEndDay = AuthService.getRoleAccess(PERMISSION_CONSTANTS.START_DAY_AND_END_DAY);

    let mainActivityListItem;
    let pendingActivityListItem;
    let adminFDOLists;
    const { tableName } = this.state;
    if (!showBulkUpload?.view) {
      mainActivityListItem = activityList?.map((activity, i) =>
        <ActivityItem activity={activity} key={i} getActivityItem={this.getActivityItem} handleDelete={this.handleDelete} handleActivitiesEdit={this.handleActivitiesEdit} />
      );

      pendingActivityListItem = pendingActivityList?.map((activity, i) =>
        <ActivityItem activity={activity} key={i} getActivityItem={this.getActivityItem} handleDelete={this.handleDelete} handleActivitiesEdit={this.handleActivitiesEdit} />
      );
    } else {
      adminFDOLists = todayData?.fdo?.map((item, i) => {
        let actvitiesStr = (item.completedActivity) + "/" + (item.totalActivity) + " activities";
        return (
          <li key={i} >
            <a onClick={() => this.handleManagerClick(item)} >
              <span className="w-25 mr-auto list-title"><b>{item.name}</b></span>
              <span className="mr-auto">{actvitiesStr}</span>
              <span className="mr-auto pending-review">{item.pendingReviewActivity} pending review</span>
              <i className="customic ic-go-button"></i>
            </a>
          </li>
        )
      });
    }

    let filteredFdoLists = fdoList.filter(fdoitem => {
      return (fdoitem.name.toLowerCase().includes(searchedValue.toLowerCase()))
    });

    let fdoListItem = filteredFdoLists.map((item, i) => {

      const isIndividualVisit = (selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_FARMER || selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_RETAILER) ? false : true;

      let name = item.name;
      if (searchedValue !== "") {
        //Utilities.LogPrint('searchedValue', searchedValue);
        let term = new RegExp(searchedValue, "gi");
        name.replace(term, function (matched) {
          return '<span class="highlight"> ' + matched + ' </span>';
        })
      }
      return (
        <li key={i}>
          <a data-toggle="modal" data-target={isIndividualVisit ? "" : "#selectIndividualVisit"} data-dismiss="modal"
            onClick={this._selectFDO.bind(this, item)}>
            {item.name}
          </a>
        </li>
      )
    });

    const enabledGo = (mobileNumber.length === 10);
    const enabledHostFarmerGo = (mobileNumber.length === 10 && hostFarmerName?.length > 0);

    let btn_name = isCheckIn ? HOME_TODAY_SCREEN.END_DAY : HOME_TODAY_SCREEN.START_DAY;
    let startTimeStr = HOME_TODAY_SCREEN.DAY_STARTED + " @ --:--";
    let endTimeStr = HOME_TODAY_SCREEN.DAY_ENDED + " @ --:--";

    if (startTime !== undefined && startTime !== null) {
      startTimeStr = HOME_TODAY_SCREEN.DAY_STARTED + " @ " + startTime;
    }
    if (endTime !== undefined && endTime !== null) {
      endTimeStr = HOME_TODAY_SCREEN.DAY_ENDED + " @ " + endTime;
    }

    let headerTitle = "Namaskar " + userName;

    const cropGroups = DataProvider.getInstance().getCropGroups();
    let isVc = false;
    if (cropGroups?.length > 0) {
      isVc = cropGroups.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS);
    }

    return (
      <div>
        <Header selectedTab={HeaderTypes.TODAY} handleSyncLoading={this.handleSyncLoading} handleSync={this.handleSync} />
        <Footer isActive={2} />

        {/* <button className="float-right" onClick={this.syncActivities}>Sync Data</button> */}

        <div className="container pt-35 pb-65">
          <div className="row">
            <div className="col-12">
              <div className="float-left">
                <p className="sub-title">{headerTitle}</p>
                <h3 className="title">{HOME_TODAY_SCREEN.YOUR_PLAN_FOR_THE_DAY}</h3>
              </div>

              <button className="btn btn-primary float-right mt-2 w-182 d-none d-lg-block ml-3"
                onClick={this.handleStartEndDay.bind(this)}
                disabled={endTime !== null && endTime !== ""}>{btn_name}
              </button>

              {showBulkUpload?.view
                ? <button className="btn btn-primary float-right mt-2 w-182 d-none d-lg-block col-12 upload-btn-mob" onClick={this.goToBulkUpload}>{HOME_TODAY_SCREEN.BULK_UPLOAD}</button>
                : null
              }

            </div>
          </div>

          {/* panel-button-wrapper d-flex changed to panel-button-wrapper d-flex custom-disabled */}
          {/* count yellow changed to count count-disabled */}
          <div className="row mt-3 fod-mobile">
            <div className="col-6 col-md-6 col-lg-6 col-xl-3">
              <div className="panel-button-wrapper d-flex">
                <div className="count yellow">{todayData?.IV}</div>
                <span>{HOME_TODAY_SCREEN.INDIVIDUAL_VISIT}</span>
                {(startTime !== null && endTime === null)
                  ? <a data-toggle="modal" data-target={!this.state.isFDO ? "#selectFDO" : "#selectIndividualVisit"}>
                    <i className="customic ic-add"></i>
                  </a>
                  : <a className={showAddIndividualVisit?.view ? "" : "d-none"} onClick={() => toast.info('Start the day to make any changes.')}>
                    <i className="customic ic-add"></i>
                  </a>
                }

              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6 col-xl-3">
              <div className="panel-button-wrapper d-flex">
                <div className="count brown">{todayData?.SD}</div>
                <span>{HOME_TODAY_SCREEN.SAMPLE_DISTRIBUTION}</span>
                {(startTime !== null && endTime === null) ?
                  <a className={(showAddSampleDistribution?.view && isVc) ? "" : "d-none"}
                    data-toggle="modal" data-target="#selectFDO"
                    onClick={() => { this.selectActivity(HomeActivityType.SAMPLE_DISTRIBUTION) }}>
                    <i className="customic ic-add"></i>
                  </a> :
                  <a className={(showAddSampleDistribution?.view && isVc) ? "" : "d-none"} onClick={() => toast.info('Start the day to make any changes.')}>
                    <i className="customic ic-add"></i>
                  </a>
                }
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6 col-xl-3">
              <div className="panel-button-wrapper d-flex">
                <div className="count blue">{todayData?.GM}</div>
                <span>{HOME_TODAY_SCREEN.GROUP_MEET}</span>
                {(startTime !== null && endTime === null) ?
                  <a className={showAddGroupMeet?.view ? "" : "d-none"}
                    data-toggle="modal" data-target="#selectFDO"
                    onClick={() => { this.selectActivity(HomeActivityType.GROUP_MEET) }}
                  ><i className="customic ic-add"></i>
                  </a> :
                  <a className={showAddGroupMeet?.view ? "" : "d-none"} onClick={() => toast.info('Start the day to make any changes.')}>
                    <i className="customic ic-add"></i>
                  </a>
                }
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6 col-xl-3">
              <div className="panel-button-wrapper d-flex">
                <div className="count green">{todayData?.S2S}</div>
                <span>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE}</span>
                {(startTime !== null && endTime === null) ?
                  <a className={showAddSampleToSale?.view ? "" : "d-none"}
                    data-toggle="modal" data-target="#selectFDO"
                    onClick={() => { this.selectActivity(HomeActivityType.SAMPLE_TO_SALE) }}
                  ><i className="customic ic-add"></i>
                  </a> :
                  <a className={showAddSampleToSale?.view ? "" : "d-none"} onClick={() => toast.info('Start the day to make any changes.')}>
                    <i className="customic ic-add"></i>
                  </a>
                }

                {/* <a className={showAddSampleToSale ?.view ? "" : "d-none"} onClick={() => this._handleAddActivity(HomeActivityType.SAMPLE_TO_SALE)}>
                  <i className="customic ic-add"></i>
                </a> */}
              </div>
            </div>
          </div>

          {/* ROLE BASED UI FOR MANAGER AND FDO */}

          {/* FDO DESIGN */}
          <div className={!showBulkUpload?.view ? "row" : "row d-none"}>
            <div className="col-12">
              <div className="row">
                <div className="col-12 pt-lg-3 pb-lg-0 pt-2 pb-2">
                  <span className="fod-time">{startTimeStr}</span>
                </div>
              </div>

              <div className="row">
                <div className="col-12 px-sm-3 px-0">
                  <ul className="fod-list">
                    {mainActivityListItem}
                  </ul>
                </div>
              </div>

              <div className="row pending-activities">
                <div className="col-12 px-sm-3 px-0">
                  <div className="pending-act-header collapsed" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                    <a href="/#" className="mr-auto font-weight-bold">{HOME_TODAY_SCREEN.PENDING_ACTIVITIES}</a>
                    <i className="customic ic-go-button"></i>
                  </div>
                </div>
                <div className="col-12 px-sm-3 px-0 pending-act-body collapse" id="collapseExample">
                  <ul className="fod-list">
                    {pendingActivityListItem}
                  </ul>
                </div>
              </div>

              <div className="row">
                <div className="col-12 pt-lg-3 pb-lg-0 pt-2 pb-2">
                  <span className="fod-time">{endTimeStr}</span>
                </div>
              </div>
            </div>
          </div>

          {/* MANAGER DESIGN */}
          <div className={showBulkUpload?.view ? "row" : "row d-none"}>
            <div className="col-12 mt-33">
              <ul className="review-list">
                {adminFDOLists}
              </ul>
            </div>
          </div>

          {/* FOR MOBILE START DAY END DAY BUTTON */}
          <div className="row">
            <div className="col-12">
              <button className="btn btn-primary float-right mt-2 mb-3 w-100 d-block d-lg-none"
                onClick={this.handleStartEndDay.bind(this)}
                disabled={endTime !== null && endTime !== ""}>{btn_name}
              </button>
            </div>
          </div>
        </div>

        {/* SELECT FDO POPUP */}
        <div className="modal fade bottom-drawer" id="selectFDO" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close d-md-block" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <h6>Select FDO</h6>
                <div className="form-group search-box">
                  <input type="text" className="form-control" placeholder="Search" onChange={this._handleChange} />
                  <i className="customic ic-search"></i>
                </div>
                <ul className="drawer-menu-list search-list">
                  {fdoListItem}
                </ul>

              </div>
            </div>
          </div>
        </div>

        {/* FARMER & RETAILER POPUP */}
        <div className="modal fade bottom-drawer" id="selectIndividualVisit" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.INDIVIDUAL_VISIT} to</h6>
                <ul className="drawer-menu-list">
                  <li>
                    <a onClick={() => this._handleAddActivity(HomeActivityType.INDIVIDUAL_VISIT_FARMER)} data-dismiss="modal">
                      {HOME_TODAY_SCREEN.FARMER}
                    </a>
                  </li>
                  <li>
                    <a onClick={() => this._handleAddActivity(HomeActivityType.INDIVIDUAL_VISIT_RETAILER)} data-dismiss="modal">
                      {HOME_TODAY_SCREEN.RETAILER}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* MOBILE NUMBER POPUP */}
        <div className="modal fade bottom-drawer" id="homeFarmerMobileModal" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER}</h6>
                <form action="">
                  <div className="form-group mobile-number-input">
                    <label>+91 -</label>
                    <input type="tel"
                      className="form-control"
                      maxLength="10"
                      name="mobileNumber"
                      onChange={this.verifyNumber} />
                  </div>

                  <button className="btn btn-primary w-100 mb-2"
                    onClick={this.getKrishakByReferenceIdApi}
                    data-dismiss="modal"
                    disabled={!enabledGo}
                  >{HOME_TODAY_SCREEN.GO}</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Join Group Bottom Drawers */}
        <div className="modal fade bottom-drawer" id="joinGroupMeeting" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <h6 className="font-weight-medium">Are you conducting group meeting at the field of the farmer?</h6>
                <ul className="drawer-menu-list">
                  <li>
                    <a data-toggle="modal"
                      data-target="#homeFarmerMobileModal"
                      data-dismiss="modal"
                      onClick={() => this.setState({ isHost: false })}>YES
                    </a>
                  </li>
                  <li>
                    <a data-toggle="modal"
                      data-dismiss="modal"
                      data-target="#hostFarmerMobileModal"
                      onClick={() => this.setState({ isHost: true })}>NO
                    </a>
                  </li>
                  {/* <li><a data-dismiss="modal" onClick={this.goToGroupMeeting}>NO</a></li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>


        {/* MOBILE NUMBER & HOST FARMER POPUP */}
        <div className="modal fade bottom-drawer" id="hostFarmerMobileModal" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER}</h6>
                <form action="">
                  <div className="form-group mobile-number-input">
                    <label>+91 -</label>
                    <input type="tel"
                      className="form-control"
                      maxLength="10"
                      name="mobileNumber"
                      onChange={this.verifyNumber} />
                  </div>

                  <label>Host Farmer Name</label>
                  <div className="form-group">
                    <input type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      value={hostFarmerName}
                      onChange={(event) => {
                        this.setState({ hostFarmerName: event.target.value });
                      }} />
                  </div>

                  <button className="btn btn-primary w-100 mb-2"
                    onClick={this.goToGroupMeeting}
                    data-dismiss="modal"
                    disabled={!enabledHostFarmerGo}
                  >{HOME_TODAY_SCREEN.GO}</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
        <DesktopFooter />
        {isLoading ? <Loader /> : null}
      </div>
    )
  }
}

export default withRouter(HomeTodayPage)